import Barchart from './Barchart';

export default Barchart;
